var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex w-full flex-wrap flex-col sm:flex-row relative"},[_c('div',{staticClass:"flex w-full sm:w-3/4_"},[_c('quick-button-menu',{attrs:{"buttons":_vm.quickButtonMenu()}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }